import React, { Fragment, useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import './Login.css';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { delete_cookie } from 'sfcookies';
import { TextField } from '@mui/material';
import useUtils from '../utiles/useUtiles';
import { ToastContainer } from 'react-toastify';
import Footer from '../main/components/Footer';

const AccountRecovery: React.FC = () => {
    const navigate = useNavigate();
    const { axiosRequest, baseUrl, toastInstance , handleError, loadingScreen } = useUtils();
    const axios = axiosRequest();
    const toast = toastInstance();

    const [email, setEmail] = useState<string>( '' );
    const [password, setPassword] = useState<string>( '' );
    const [reset, setReset] = useState<boolean>( false );
    const [recovery, setRecovery] = useState<boolean>( false );
    const [show, setShow] = useState<boolean>( false );
    const [isDisabled, setIsDisabled] = useState<boolean>( false );
    const [loading, setLoading] = useState<boolean>( false );
    // const [showAlert, setShowAlert] = useState<boolean>( false );

    async function getResetPassword() {
        try {
            const url = window.location.search;
            const params = new URLSearchParams( url );
            const reset_password = params.get( 'reset' );
            if ( reset_password === 'true' ) {
                setRecovery( false );
                setReset( false );
                setShow( true );
                const token = params.get( 'token' );
                const request = await axios.get( `${baseUrl()}/csv-tool/reset/${token}` );
                const { error } = request.data;
                if ( error === false ) {
                    setShow( false );
                    setRecovery( false );
                    setReset( true );
                } else {
                    setShow( false );
                    setRecovery( true );
                    toast.error( 'Invalid Token' );
                }
            } else {
                setReset( false );
                setRecovery( true );
                setShow( false );
            }
        } catch ( e: any ) {
            handleError( e );
        }
    }

    useEffect( () => {
        getResetPassword().then( null );
    }, [] );

    function onChangeHandler( e: any ) {
        const { name, value } = e.target;
        if ( name === 'email' ) setEmail( value );
        if ( name === 'password' ) setPassword( value );
    }

    async function resetPassword( e: any ) {
        try {
            setLoading( true );
            e.preventDefault();
            if ( email === '' ) {
                toast.error( 'Please insert your email' );
                setLoading( false );
                return;
            }
            setIsDisabled( true );
            const request = await axios.post( `${baseUrl()}/csv-tool/recovery`, { email } );
            const { error, msg } = request.data;
            setLoading( false );
            if ( error ) {
                toast.error( msg );
            } else {
                setEmail( '' );
                toast.success( 'Please check your email address to reset your password' );
                redirectToLogin();
            }

            // setEmail( '' );
            // setLoading( false );
            // setShowAlert( true );
        } catch ( error: any ) {
            setIsDisabled( false );
            setLoading( false );
            handleError( error );
        }
    }

    function redirectToLogin() {
        delete_cookie( 'admin_pppcalc' );
        navigate( "/" );
        // window.history.replaceState( '', '', '/' );
        // window.location.reload();
    }

    return (
      <>
        <div className="container noauth-container">
            <div className="row">
                <div className="col-sm-12">
                    <div className="main-container">
                        {/* <div className="logo mb-3"><img src="/logo-min.png" /></div> */}
                        <div className="main-card">
                            <h1 className="text-center mb-4">Forgot Password</h1>
                            {/* <p className="text-center">Please set me up with a new password</p> */}
                            <p className="text-center">
                              To reset your password, enter your email <br />address and we'll send you an email with instructions.
                            </p>
                            <div className="mb-4">
                                {/* <TextField
                                  variant="outlined"
                                  autoFocus
                                  fullWidth
                                  label="Email"
                                  onChange={onChangeHandler}
                                  placeholder="Email"
                                  type="email"
                                  value={email}
                                  name="email"
                                /> */}
                                <label>Email</label>
                                <input type="text" className="form-control" value={email} name="email" onChange={onChangeHandler} />
                                
                            </div>
                            <div className="d-flex gap-3">
                                <Link to='/' className="revrex-outline-btn mr-3">Back to Login</Link>
                                {/* <a href="/" className="revrex-outline-btn mr-3">Back to Login</a> */}
                                <Link to='#' className="revrex-primary-btn" onClick={resetPassword}>Submit</Link>
                                {/* <a href="#" className="revrex-primary-btn" onClick={resetPassword}>Submit</a> */}
                            </div>
                        </div>

                    </div>
                    <Footer />
                </div>
            </div>
        </div>
        {/* <SweetAlert
          show={showAlert}
          onCancel={() => redirectToLogin()}
          title="Recover email sent"
          text={`An email with instructions on how to reset your password has been sent to ${email}. Check your spam or junk folder if you don’t see the email in your inbox.`}
          onConfirm={() => redirectToLogin()}
        /> */}

        {/* <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        /> */}
        {loadingScreen( loading )}
      </>
    );
}

export default AccountRecovery;
